import axios from './../http'

function query(data) {
    return axios.post('/sys/param/query', data);
}

function get(id) {
    return axios.get('/sys/param/get?id=' + id);
}

function add(data) {
    return axios.post('/sys/param/add', data);
}

function update(data) {
    return axios.post('/sys/param/update', data);
}

function del(data) {
    return axios.post('/sys/param/del', data);
}

function valid(data) {
    return axios.post('/sys/param/valid', data);
}
function invalid(data) {
    return axios.post('/sys/param/invalid' , data);
}

export default {
    query,
    get,
    add,
    update,
    del,
    valid,
    invalid
}